import React from 'react';
import { ArrowRight, ExternalLink, FileText } from 'lucide-react';
import { motion } from 'framer-motion';
import * as amplitude from '@amplitude/analytics-browser';

export function CtaSection() {
  return (
    <section className="py-12 sm:py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative overflow-hidden bg-gradient-to-br from-emerald-500 via-teal-500 to-cyan-500 rounded-3xl p-8 sm:p-12 text-center"
        >
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1517760444937-f6397edcbbcd?q=80&w=2670&auto=format&fit=crop')] bg-cover bg-center opacity-10" />
          <div className="relative">
            <h2 className="text-xl sm:text-3xl font-bold text-white mb-3">
              Pret a partir l'esprit tranquille ?
            </h2>
            <p className="text-sm sm:text-base text-white/80 mb-8 max-w-xl mx-auto">
              Souscrivez des maintenant a Globe PVT et profitez d'une couverture complete adaptee a votre PVT.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-3">
              <a
                href="https://www.acs-ami.com/fr/part/pvtistes/globe-pvt/?part=pvtistes&utm_source=pvtistes-pwa&utm_medium=aff-link&utm_campaign=gp-pvt-pwa"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => amplitude.track("Insurance CTA Clicked", { location: "bottom-cta" })}
                className="group inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white text-emerald-600 font-bold rounded-xl shadow-xl shadow-black/10 hover:shadow-2xl hover:scale-[1.02] transition-all duration-300 active:scale-[0.98]"
              >
                <span>Souscrire a Globe PVT</span>
                <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-0.5" />
              </a>
              <a
                href="https://clems.acs-ami.com/fr/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-medium rounded-xl transition-all border border-white/20"
              >
                <span>Demande de remboursement</span>
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          </div>
        </motion.div>

        <div className="mt-12 sm:mt-16">
          <h3 className="text-base sm:text-lg font-bold text-gray-900 dark:text-white mb-6 text-center">
            Documents d'information
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[
              { title: 'Notice Globe PVT Canada', url: 'https://www.acs-ami.com/files/pdf/Globe-PVT-EIC-Canada-IB-fr.pdf' },
              { title: 'Notice Globe PVT autres destinations', url: 'https://www.acs-ami.com/files/pdf/Globe-PVT-WHV-IB-fr.pdf' },
              { title: 'Tableau de garanties Globe PVT', url: 'https://www.acs-ami.com/files/pdf/Globe-PVT-TG-fr.pdf' },
            ].map((doc) => (
              <a
                key={doc.title}
                href={doc.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 p-4 bg-gray-50 dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700/50 hover:border-emerald-200 dark:hover:border-emerald-700 hover:shadow-md transition-all duration-300 group"
              >
                <div className="w-10 h-10 rounded-xl bg-emerald-50 dark:bg-emerald-900/20 flex items-center justify-center flex-shrink-0">
                  <FileText className="w-5 h-5 text-emerald-500 dark:text-emerald-400" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 dark:text-white truncate">{doc.title}</p>
                  <p className="text-xs text-emerald-600 dark:text-emerald-400 mt-0.5 group-hover:underline">Telecharger le PDF</p>
                </div>
                <ArrowRight className="w-4 h-4 text-gray-400 dark:text-gray-500 transition-transform group-hover:translate-x-0.5 flex-shrink-0" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
